import { Doughnut } from 'react-chartjs-2';

import { formatMoney } from '../../utils/helpers/aiSpendFormat';
import { colorForKey, registerCharts } from './chartSetup';
import useChartTheme from './useChartTheme';

registerCharts();

/**
 * A share-of-total ring.
 *
 * `segments` must come from a real breakdown of the dimension being charted --
 * never from a top-N list of something else. A donut asserts that its parts are
 * commensurable and sum to a meaningful whole; feeding it top models while
 * labelling it "by provider" produces several slices with the same name and a
 * total that means nothing.
 */
export default function DoughnutChart({
  segments,
  valueFormatter = formatMoney,
  ariaLabel,
}) {
  const theme = useChartTheme();

  const data = {
    labels: segments.map((segment) => segment.label),
    datasets: [
      {
        data: segments.map((segment) => segment.value),
        backgroundColor: segments.map((segment, index) =>
          segment.color || colorForKey(segment.key, index),
        ),
        borderColor: theme.surface,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 120,
    cutout: '62%',
    plugins: {
      legend: { position: 'right', labels: { color: theme.tick, boxWidth: 10 } },
      tooltip: {
        ...theme.tooltip,
        callbacks: {
          label: (context) => `${context.label}: ${valueFormatter(context.parsed)}`,
        },
      },
    },
  };

  return (
    <Doughnut
      key={theme.isDark ? 'dark' : 'light'}
      data={data}
      options={options}
      role="img"
      aria-label={ariaLabel}
    />
  );
}
